import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatAllotService } from '@app/shared/services/mat-allot.service';

@Component({
  selector: 'app-process',
  templateUrl: './process.component.html',
  styleUrls: ['./process.component.css']
})
export class ProcessComponent implements OnInit {
  mixMatList: any[] = [];
  displayedList: any[] = []; // This is used to display the filtered and paginated list
  itemsPerPage: number = 15;
  currentPage: number = 1;
  totalItems: number;
  sortDirection: string = 'asc';
  sortColumn: string = ''; // To keep track of the currently sorted column
  searchText: string = ''; // For search functionality

  constructor(private matAllot: MatAllotService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.getAllMatMix();
  }

  getAllMatMix() {
    this.matAllot.getAllMatAllot().subscribe(
      (res: any) => {
        this.mixMatList = res.reverse();
        this.totalItems = this.mixMatList.length;
        this.updateDisplayedList();
        this.cdr.detectChanges(); // Trigger change detection
      },
      (error) => {
        console.error('Error fetching material allotment list:', error);
      }
    );
  }

  onSortColumn(column: string) {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    this.sortColumn = column;
    this.mixMatList.sort((a, b) => {
      const valueA = a[column];
      const valueB = b[column];
      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      }
      if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      }
      return 0;
    });
    this.updateDisplayedList();
  }

  deleteRow(itemId: string) {
    const isConfirmed = confirm('Are you sure you want to delete this entry?');
    if (isConfirmed) {
      this.matAllot.deleteMatAllot(itemId).subscribe(
        () => {
          this.mixMatList = this.mixMatList.filter(item => item._id !== itemId);
          this.totalItems = this.mixMatList.length;
          this.updateDisplayedList();
          this.cdr.detectChanges(); // Trigger change detection
        },
        (error) => {
          console.error('Error deleting row:', error);
        }
      );
    }
  }

  updateDisplayedList() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.displayedList = this.mixMatList.slice(startIndex, endIndex);
  }

  getPages(): number[] {
    const totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  onPageChange(page: number) {
    if (page >= 1 && page <= Math.ceil(this.totalItems / this.itemsPerPage)) {
      this.currentPage = page;
      this.updateDisplayedList();
    }
  }
}
